import { Routes } from "@angular/router";
import { authRoutes } from "./pages/auth/auth.routes";
import { AuthGuard } from "./core/guards/auth-guard.service";
import { mantenimientoRoutes } from "./pages/mantenimiento/mantenimiento.routes";

export const appRoutes: Routes = [
  { path: "", redirectTo: "mantenimiento", pathMatch: "full" },

  {
    path: "auth-callback",
    loadComponent: () =>
      import("./pages/auth/auth-callback/auth-callback.component").then(
        (m) => m.AuthCallbackComponent,
      ),
  },

  {
    path: "logout",
    loadComponent: () =>
      import("./pages/auth/logout/logout.component").then(
        (m) => m.LogoutComponent,
      ),
  },

  // PUBLICO
  {
    path: "login",
    loadComponent: () =>
      import("./pages/auth/auth.component").then((m) => m.AuthComponent),
    children: authRoutes,
  },

  // PRIVADO
  {
    path: "",
    canActivate: [AuthGuard],
    children: [...mantenimientoRoutes],
  },

  { path: "**", redirectTo: "mantenimiento" },
];
